module.exports = __webpack_public_path__ + "img/unit3-architectural.bd62e556.svg";